import React, { useEffect, useState } from 'react'
import moment from 'moment'

//antd
import {
  Form,
  Drawer,
  Row,
  Col,
  Button,
  Input,
  notification,
  DatePicker,
  Select,
  InputNumber,
} from 'antd'

//apis
import { addGiftcard, updateGiftcard } from 'apis/giftcard'
import { getBranches } from 'apis/branch'
import { getRoles } from 'apis/role'
import { getCountries } from 'apis/country'
//components
import SearchAddress from 'components/search-address'

export default function GiftCardForm({ children, reloadData, record }) {
  const [form] = Form.useForm()

  const [branchs, setBranchs] = useState([])
  const [roles, setRoles] = useState([])
  const [address, setAddress] = useState([])
  const [countries, setCountries] = useState([])

  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)

  const _addOrEditGiftCard = async () => {
    try {
      await form.validateFields()
      const dataForm = form.getFieldsValue()

      setLoading(true)
      const body = {
        ...dataForm,
      }
      let res
      if (record) res = await updateGiftcard(record.giftcard_id, body)
      else res = await addGiftcard(body)
      if (res.status === 200) {
        if (res.data.success) {
          toggle()
          reloadData()
          notification.success({
            message: `${record ? 'Cập nhật' : 'Thêm'} giftcard thành công`,
          })
        } else
          notification.error({
            message:
              res.data.message ||
              `${record ? 'Cập nhật' : 'Thêm'} giftcard thất bại, vui lòng thử lại`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${record ? 'Cập nhật' : 'Thêm'} nhân viên thất bại, vui lòng thử lại`,
        })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _getRoles = async () => {
    try {
      const res = await getRoles()
      if (res.status === 200) setRoles(res.data.data.filter((e) => e.role_id !== -1))
    } catch (error) {
      console.log(error)
    }
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    _getCountries()
    _getRoles()
  }, [])

  useEffect(() => {
    if (visible) {
      if (!record) {
        form.resetFields()
      } else {
        form.setFieldsValue({
          ...record,
          birthday: record.birthday ? moment(record.birthday) : null,
          branch_ids: record.branch_info && record.branch_info[0] ? record.branch_info[0].name : '',
        })
      }
    }
  }, [visible])

  return (
    <>
      <div onClick={toggle}>{children}</div>
      <Drawer
        width="70%"
        footer={
          <Row justify="end">
            <Button
              onClick={_addOrEditGiftCard}
              loading={loading}
              size="large"
              type="primary"
              style={{ width: 120 }}
            >
              {record ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        }
        title={`${record ? 'Cập nhật' : 'Thêm'} giftcard`}
        placement="right"
        onClose={toggle}
        visible={visible}
      >
        <Form layout="vertical" form={form}>
          <Row justify="space-between" align="middle">
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item label="Tiêu đề" name="title">
                <Input placeholder="Tiêu đề (tên)" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item
                label="Giá trị (giá bán)"
                name="value"
                rules={[{ required: true, message: 'Vui lòng nhập giá bán' }]}
              >
                <InputNumber placeholder="Giá bán" style={{ width: 300 }} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={11} lg={11} xl={11}>
              <Form.Item
                label="Quốc gia"
                name="country_ids"
                rules={[{ message: 'Vui lòng chọn quốc gia!', required: true }]}
              >
                <Select placeholder="Chọn quốc gia">
                  {countries.map((country, index) => (
                    <Select.Option value={country.country_id} key={index}>
                      {country.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  )
}
